export enum roles
{
    Admin = 1,
    Customer = 2,
}